import React, {createContext, useState} from 'react';
import PMSGenericService from "../../services/pms_services/PMSGenericService";
import {getPharmacyId} from "../../helpers/Utils";
import Notification from "../../components/common/Notification";

export const PMSGenericContext = createContext("PMSGenericContext");


const PMSGenericContextProvider = ({children}) => {

    const [generics, setGenerics] = useState([]);
    const [generic, setGeneric] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [totalElements, setTotalElements] = useState(0);

    const pharmacyId = getPharmacyId();

    async function getAllGenerics(data) {

        try {
            setLoading(true);
            setErrorMsg('');
            // const res = await PMSGenericService.getAllGenerics(pharmacyId,{page, size, id, genericName});
            const res = await PMSGenericService.getAllGenerics(pharmacyId, data);
            setTotalElements(res.data.totalElements);
            setGenerics(res.data.content);
            setLoading(false);
            return res.data.content;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not load Generics. Please check the console.");
            console.log("error", console.error());
            return false;
        }

    }


    async function getGenericById(id) {

        try {
            setLoading(true);
            setErrorMsg('');
            const res = await PMSGenericService.getGenericById(id, pharmacyId);
            setGeneric(res.data);
            setLoading(false);
            return res.data;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not load Generic. Please check the console.");
            console.log("error", console.error());
            return false;
        }

    }

    async function addGeneric(data) {

        try {
            setErrorMsg('');
            setLoading(true);
            const res = await PMSGenericService.addGeneric(data, pharmacyId)
            setGenerics(generics ? [...generics, res.data] : [res.data]);
            setLoading(false);
            return res.data;
        } catch (error) {
            setLoading(false);

            let _error = "Something went wrong.";

            if (error.message === "Network Error") {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }
            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }

    }

    async function updateGeneric(DATA, id) {
        try {
            setLoading(true);
            setErrorMsg('');
            const res = await PMSGenericService.updateGeneric(DATA, id, pharmacyId);
            setGeneric(res.data);
            let updatedGenerics = generics;
            updatedGenerics = generics.map(e => {
                if (e.id === id) e = res.data;
                return e;
            })

            setGenerics(updatedGenerics);
            setLoading(false);
            return true;
        } catch (error) {
            // debugger
            // setLoading(false);
            // setErrorMsg("Can not update Generic. Please check the console.");
            // console.log("Generic update error.", error);
            // return false;
            setLoading(false);

            let _error = "Something went wrong.";

            if (error.message === "Network Error") {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }
            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }

    }

    async function deleteGeneric(id) {

        if (!window.confirm("Are you sure you want to delete this Generic ?")) return;

        try {
            setLoading(true);
            setErrorMsg('');
            await PMSGenericService.deleteGeneric(id, pharmacyId);
            let updatedGenerics = generics;
            updatedGenerics = generics.filter(e => e.id !== id);
            setGenerics(updatedGenerics);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not delete Generics. Please check the console.");
            console.log("Generic delete error.", error);
            return false;
        }
    }


    return (
        <PMSGenericContext.Provider
            value={{
                generics,
                generic,
                loading,
                errorMsg,
                totalElements,
                getAllGenerics,
                updateGeneric,
                getGenericById,
                deleteGeneric,
                addGeneric
            }}
        >
            {children}
        </PMSGenericContext.Provider>
    );
}

export default PMSGenericContextProvider;
